import { dynamicImage } from "../../../Service/DynamicImage";

// Simple Tab
export const TABS_DATA = [
  {
    text: "Use the ",
    code: ".nav-link",
  },
  {
    text: " with ",
    code: ".show ",
  },
  {
    text: "class to jump particular tabs.",
  },
];

//Icons With Tab
export const ICON_TABS_DATA = [
  {
    text: "Use the ",
    code: ".nav-link",
  },
  {
    text: "with feather icons. And ",
    code: ".show ",
  },
  {
    text: " class to tabs change.",
  },
];

//Vertical Tab
export const VERTICAL_TABS_DATA = [
  {
    text: "Use the ",
    code: ".nav-link",
  },
  {
    text: "with feather icons. And ",
    code: ".show ",
  },
  {
    text: " class to tabs change.",
  },
];

//Pills Tabs
export const PILLS_TABS_DATA = [
  {
    text: "Use the ",
    code: "data-bs-toggle='pill'",
  },
  {
    text: " to tabs pill shape. And mandatory for ",
    code: "active ",
  },
  {
    text: " class.",
  },
];

//Justify Tabs
export const JUSTIFY_TABS_DATA = [
  {
    text: "Use the ",
    code: ".nav-link",
  },
  {
    text: " with ",
    code: ".active ",
  },
  {
    text: "class and set content using flex property.",
  },
];

export const DATA = [
  {
    id: "1",
    items: [
      {
        src: dynamicImage("avtar/3.jpg"),
        title: "Kathy M. Anderson",
        number: "440-494-0729",
      },
      {
        src: dynamicImage("avtar/4.jpg"),
        title: "Lillian J. Goodfellow",
        number: "239-664-7751",
      },
      {
        src: dynamicImage("avtar/7.jpg"),
        title: "Carolyn A. Sutton",
        number: "218-793-6609",
      },
      {
        src: dynamicImage("avtar/11.jpg"),
        title: "Mary O. Miller",
        number: "720-744-0921",
      },
      {
        src: dynamicImage("avtar/16.jpg"),
        title: "Patricia H. Hummel",
        number: "314-445-1451",
      },
      {
        src: dynamicImage("avtar/4.jpg"),
        title: "Minnie F. Evans",
        number: "718-740-8438",
      },
    ],
  },
  {
    id: "2",
    items: [
      {
        src: dynamicImage("blog/9.jpg"),
        title: "Thomas A. Leroy",
        number: "305-539-6871",
      },
      {
        src: dynamicImage("blog/12.png"),
        title: "Mark S. Ward",
        number: "303-561-8880",
      },
      {
        src: dynamicImage("blog/14.png"),
        title: "Emily T. Hooper",
        number: "301-553-1836",
      },
      {
        src: dynamicImage("blog/comment.jpg"),
        title: "Natasha W. Watson",
        number: "267-605-4499",
      },
      {
        src: dynamicImage("blog/9.jpg"),
        title: "Jennifer A. Camacho",
        number: "770-527-7554",
      },
      {
        src: dynamicImage("avtar/3.jpg"),
        title: "Ann J. Strickland",
        number: "469-218-4678",
      },
    ],
  },
  {
    id: "3",
    items: [
      {
        src: dynamicImage("avtar/11.jpg"),
        title: "Jaclyn T. Duncan",
        number: "413-618-9222",
      },
      {
        src: dynamicImage("avtar/16.jpg"),
        title: "MChristine H. Lin",
        number: "909-219-0342",
      },
      {
        src: dynamicImage("avtar/3.jpg"),
        title: "Ronnie S. Mountain",
        number: "978-426-9732",
      },
      {
        src: dynamicImage("blog/12.png"),
        title: "Louise A. Hilliard",
        number: "502-262-5600",
      },
      {
        src: dynamicImage("blog/comment.jpg"),
        title: "Kayla Hutt",
        number: "312-456-8275",
      },
      {
        src: dynamicImage("blog/4.jpg"),
        title: "Amber Cecil",
        number: "802-662-2407",
      },
    ],
  },
];

//Material Style Left Tabs
export const MATERIAL_DATA = [
  {
    text: "Use the ",
    code: ".nav-link",
  },
  {
    text: " with ",
    code: ".active ",
  },
  {
    text: "class through jump another tabs.And ",
    code: "aria-orientation='vertical'",
  },
  {
    text: "class through jump another tabs.And ",
  },
];

//Material Style Tab
export const MATERIAL_STYLE_DATA = [
  {
    text: "Use the ",
    code: ".nav-link",
  },
  {
    text: " with ",
    code: ".active ",
  },
  {
    text: "class through access new tabs. And icons of design for attractive webpage.",
  },
];

const Star = ()=>{
  return(<i className="ico-color icofont icofont-star"></i>)
}

export const MATERIAL_STYLE_LIST = [
  {
    tabId: "1",
    header: "User Details:",
    tableHeaders: ["#", "Name", "Country", "Contact No"],
    tableData: [
      { id: 1, name: "Neha", country: "India", contactNo: "5698741236" },
      { id: 2, name: "Jacklin", country: "Thailand", contactNo: "7800030320" },
    ],
  },
  {
    tabId: "2",
    header: "Description:",
    tableHeaders: ["Technology", "Interest", "Salary Expected"],
    tableData: [
      { technology: "Web Designer", interest: "HTML,CSS,JS,SCSS", salaryExpected: "45000" },
      { technology: "UX Designer", interest: "Figma,Photoshop,craft", salaryExpected: "20000" },
    ],
  },
  {
    tabId: "3",
    header: "Review:",
    tableHeaders: ["#", "Name", "Country", "Rating"],
    tableData: [
      { id: 1, name: "Neha", country: "India", rating:<><Star/><Star/><Star/><Star/></>},
      { id: 3, name: "Irfan", country: "India", rating: <><Star/><Star/><Star/></>}
    ],
  },
];

//Border Tab
export const BORDER_TAB_DATA = [
  {
    text: "Use the ",
    code: ".nav-link",
  },
  {
    text: " with ",
    code: ".active ",
  },
  {
    text: "class. And hover effect added on bottom border styles.",
  },
];
